import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';
// pages
// components
import LoadingScreen from '../../../../components/LoadingScreen';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, validateCareflowToken } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && !validateCareflowToken()) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to="/auth/login" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    console.log('DEBUG requestedLocation before clear: ', requestedLocation);
    setRequestedLocation(null);
    console.log('DEBUG requestedLocation after clear: ', requestedLocation);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
